module.exports = __webpack_public_path__ + "img/SES_205141500.5c4c384e.jpg";